import { Component, OnInit, Input } from "@angular/core";
import { ReportLine } from "../../../../../_objects/report-element";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-line-container-offline",
  templateUrl: "./report-line.component.html",
  styleUrls: ["./report-line.component.scss"],
  standalone: false
})
export class ReportLineOfflineComponent implements OnInit {
  @Input() pageKey: string;
  @Input() lineKey: string;
  @Input() public elementLocation: string;

  reportLine: ReportLine;
  private resizeMarkerSize: number;
  private resizing: boolean;
  private notifier: Notifier;

  readonly reportLineStyle = "position: absolute; word-break: normal; white-space: pre-wrap;";

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  ngOnInit() {
    this.notifier = {
      componentName: "report-line.component",
      ids: { pageId: this.pageKey, elementId: this.lineKey }
    };
    this.reportLine = this.designService.getLine(this.lineKey);
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "right":
        return this.reportLine.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    if (vertical === "middle") {
      return this.reportLine.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
    } else {
      return "";
    }
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;

    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
